import React from 'react';
import Dialog from 'src/components/common/Dialog';
import DialogList from 'src/dialogs';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';

export interface ILeaseInfoDeleteDialogProps {
    onDelete: () => void;
}

const LeaseInfoDeleteDialog = (props: ILeaseInfoDeleteDialogProps) => {

    return (
              <Dialog dialogName={DialogList.DELETE_LEASE} title={'Confirm Lease Deletion!'}>
                <div>
                    <RHFLegend title="Confirm Lease Deletion"/>
                    <div>
                        <Button text="DELETE" onClick={props.onDelete}/>
                    </div>
                </div>
              </Dialog>

    );
};

export default LeaseInfoDeleteDialog;


// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/LeaseInfoDeleteDialog.tsx